import { render, staticRenderFns } from "./filesInfo.vue?vue&type=template&id=5c6b21b9&scoped=true"
import script from "./filesInfo.vue?vue&type=script&lang=js"
export * from "./filesInfo.vue?vue&type=script&lang=js"
import style0 from "./filesInfo.vue?vue&type=style&index=0&id=5c6b21b9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c6b21b9",
  null
  
)

export default component.exports